import Analytics from "analytics";
import mixpanelPlugin from "./mixpanelProxy";
import ga4Plugin from './ga4Plugin.ts'
import teacherPlugin from './teacherPlugin.ts'

const PLUGINS = []

if(process.env.NEXT_PUBLIC_MIXPANEL_DISABLE !== 'true')
    PLUGINS.push(        
        mixpanelPlugin({
            token: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
        }),
    )

if(process.env.NEXT_PUBLIC_GA_DISABLE !== 'true')
    PLUGINS.push(
        ga4Plugin({
            trackingId: process.env.NEXT_PUBLIC_GA_TRACKING_ID,
        })
    )

if(process.env.NEXT_PUBLIC_TEACHER_ANALYTICS_DISABLE !== 'true')
    PLUGINS.push(
        teacherPlugin()
    )

export const analytics = Analytics({
    app: "sets-gamify",
    plugins: PLUGINS
});

export const addPrefix = (obj: any, prefix: string) => {
    if (!obj) {
        return null;
    }

    function fromEntries(entries) {
        const res = {};
        for (let i = 0; i < entries.length; i++)
            res[entries[i][0]] = entries[i][1];
        return res;
    }
    if (!Object.fromEntries) Object.fromEntries = fromEntries;
    if (!Object.entries)
        Object.entries = function (obj) {
            let ownProps = Object.keys(obj),
                i = ownProps.length,
                resArray = new Array(i); // preallocate the Array
            while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

            return resArray;
        };

    return Object.fromEntries(
        Object.entries(obj).map(([k, v]) => [`${prefix}_${k}`, v]),
    );
};
